import React from 'react'
import logo from '../images/SHIV_SHANKAR_HYDRO_SOLUTION-removebg-preview.png'
import WhatsAppButton from '../modules/Whatsapp'
const Landingpage = () => {
    return (
        <div className='landingpage'>
            <div className='main_sep'>
                <div className='main_intro' >
                    <h1 className='header1'>Trusted Waterproofing</h1>
                    <h1 className='header1'>and Rebaring solutions</h1>
                    <h4>Protect your property from water damage with our comprehensive waterproofing services. Experienced professionals,
                        proven solutions, and unparalleled customer satisfaction.</h4>
                    <div className='main_buttons'>
                        <button className='custom-btn btn-3'><a href='#footer1'> Contact Us</a></button>
                        {/* <button className='custom-btn btn-3'><a href="/" >View Quataion</a></button> */}
                        <WhatsAppButton/>
                    </div>
                </div>
                <img src={logo} className='logoimg' alt='logo'/>
            </div>

        </div>
    )
}

export default Landingpage
